import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AddressView, BuildingView } from '@api-proxies';
import { EditorComponentBase } from 'ngx-lib';
import { LocationDetailsComponent } from '../../location-details/location-details.component';
import { StaticMapComponent } from '../../static-map/static-map.component';
import { TypeAheadAddressesComponent } from '../../type-ahead-addresses/type-ahead-addresses.component';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-address-editor',
    templateUrl: './address-editor.component.html',
    styleUrls: ['./address-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        StaticMapComponent,
        TypeAheadAddressesComponent,
        ValidationErrorMessageComponent,
        LocationDetailsComponent
    ]
})
export class AddressEditorComponent extends EditorComponentBase<string> implements OnInit {
    @Input()
    selectedAddress?: AddressView;

    showStaticImageMap?: boolean;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.showStaticImageMap = this.additionalInfo?.staticImageMap;
        if (this.bindingProperty) {
            this.mapBuildingViewToAddressView();
        }
    }

    onSelectedAddress(address: AddressView) {
        this.selectedAddress = address;
        this.bindingProperty = this.selectedAddress?.addressLines ?? '';
        this.mapAddressViewToBuildingView();
        this.validate();
    }

    mapBuildingViewToAddressView() {
        const {
            addressId,
            line1,
            line2,
            addressLines,
            zipCode,
            latitude,
            longitude,
            countryId = 0,
            countryName,
            countryCode,
            stateId = 0,
            stateName,
            stateCode,
            cityId = 0,
            cityName,
            fullAddress,
            addressType
        } = this.bindContext as BuildingView;

        this.selectedAddress = {
            id: addressId,
            line1,
            line2,
            addressLines,
            zipCode,
            latitude,
            longitude,
            countryId,
            countryName,
            countryCode,
            stateId,
            stateName,
            stateCode,
            cityId,
            cityName,
            fullAddress,
            addressType
        };
    }

    mapAddressViewToBuildingView() {
        if (this.selectedAddress && this.bindContext) {
            for (const key in this.selectedAddress) {
                if (key in (this.bindContext as BuildingView) && key !== 'id') {
                    (this.bindContext as any)[key] = (this.selectedAddress as any)[key];
                }
            }

            (this.bindContext as BuildingView).addressId = this.selectedAddress.id;
        }
    }
}
